import i18next from "i18next";

export default function InputErrors(
  error: any,
  schema: any,
  patternError: any,
  name: any
) {
  const LocalBasePath = "errors.input";
  let errorMessage = "";
  if (!!error) {
    errorMessage = error.message;
    if (errorMessage === "") {
      switch (error.type) {
        case "minLength":
          errorMessage = i18next.t(`${LocalBasePath}.minLength`, {
            number: schema.minLength,
            name: name,
          });
          break;
        case "pattern":
          errorMessage = i18next.t(`${LocalBasePath}.wrongFormat`);
          break;
        case "required":
          errorMessage = i18next.t(`${LocalBasePath}.required`, { name: name });
          break;
        case "validate":
          errorMessage = i18next.t(`${LocalBasePath}.${error.message}`);
          break;
      }
    }
  }
  if (!errorMessage) return null;
  return (
    <div className="mt-2 text-sm text-red-600" data-cy="error-message">
      {errorMessage}
    </div>
  );
}
